import { logger } from 'utils/logger';

import StorageService from './localStorage';

const storage = new StorageService(window.localStorage, logger);

export const sessionStorage = new StorageService(window.sessionStorage, logger);

export default storage;
